import { render, staticRenderFns } from "./Introduction.vue?vue&type=template&id=b56cfe24&scoped=true"
import script from "./Introduction.vue?vue&type=script&lang=js"
export * from "./Introduction.vue?vue&type=script&lang=js"
import style0 from "./Introduction.vue?vue&type=style&index=0&id=b56cfe24&prod&scoped=true&lang=css"
import style1 from "./Introduction.vue?vue&type=style&index=1&id=b56cfe24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56cfe24",
  null
  
)

export default component.exports